export const toUint8Array = x => new Uint8Array(x.map(y => y.charCodeAt(0)))
